import AiSkeletonItem from 'components/AISkeletonItem'
import * as Styled from './styled'

const LOADING_SKELETON_DATA = [
  {
    id: crypto.randomUUID(),
    height: '86px'
  },
  {
    id: crypto.randomUUID(),
    height: '285px'
  },
  {
    id: crypto.randomUUID(),
    height: '182px'
  },
  {
    id: crypto.randomUUID(),
    height: '114px'
  }
]

export const AiContentLoading = ({ className }: { className?: string }) => {
  return (
    <Styled.AiContentLoadingWrapper className={className}>
      {LOADING_SKELETON_DATA.map(item => (
        <AiSkeletonItem key={item.id} height={item.height} />
      ))}
    </Styled.AiContentLoadingWrapper>
  )
}
